import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { CookieConsent, getStoredConsent } from './components/CookieConsent';
import { Home } from './pages/Home';
import { HowItWorks } from './pages/HowItWorks';
import { GettingStarted } from './pages/GettingStarted';
import { Why } from './pages/Why';
import { Contact } from './pages/Contact';
import { PricingPage } from './pages/PricingPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { RobotsTxt } from './pages/RobotsTxt';
import { SitemapXml } from './pages/SitemapXml';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import { TfpLandscapingPage } from './pages/CaseStudies/TfpLandscapingPage';
import { FinishCoatPaintingPage } from './pages/CaseStudies/FinishCoatPaintingPage';
import { GmailSignatureGeneratorPage } from './pages/tools/GmailSignatureGeneratorPage';
import { BlogPage } from './pages/BlogPage';
import { HowToChooseMarketingAgency } from './pages/blog/HowToChooseMarketingAgency';
import { WhyResponseTimeMakesOrBreaksYourYelpAds } from './pages/blog/WhyResponseTimeMakesOrBreaksYourYelpAds';
import { FasterYelpRepliesMoreLandscapingEstimates } from './pages/blog/FasterYelpRepliesMoreLandscapingEstimates';
import { AiReceptionistVsHumanReceptionistCost } from './pages/blog/AiReceptionistVsHumanReceptionistCost';
import { MissedCallTextBack } from './pages/blog/MissedCallTextBack';
function SiteLayout() {
  return <div className="flex min-h-screen flex-col bg-[#0a0a0a] font-sans text-neutral-100" data-id="element-0" data-mp="3dkus3sf1mymh">
      <Nav data-id="element-1" data-mp="3dii716dzo857" />
      <noscript data-id="element-2" data-mp="nvsup6ui4rx0">
        <div style={{
        padding: '2rem',
        maxWidth: '800px',
        margin: '0 auto'
      }} data-id="element-3" data-mp="nwc39wy9i3yd">
          <h1 data-id="element-4" data-mp="ssstcwp0use3">
            Viridia Analytics - Phoenix Marketing Agency for Local Service
            Businesses
          </h1>
          <p data-id="element-5" data-mp="3uct0lbuzo8ws">
            We help local service businesses stop missing leads, respond
            instantly, and book more jobs. Real systems, real results from real
            Phoenix-area clients.
          </p>
          <h2 data-id="element-6" data-mp="851lvh8hilyc">Our Services</h2>
          <ul data-id="element-7" data-mp="86w60tbxma1d">
            <li data-id="element-8" data-mp="86cmj86mvdl8">
              <a href="/ai-lead-conversion" data-id="element-9" data-mp="83qhpgb4nc6p">
                AI Lead Conversion - Follow-Up, AI Receptionist, Lead Nurturing
              </a>
            </li>
            <li data-id="element-10" data-mp="3bnmgbkejr98v">
              <a href="/custom-automations" data-id="element-11" data-mp="3bo4lx7n3mztg">
                Custom Automations - Tailored Workflows, API Integrations
              </a>
            </li>
            <li data-id="element-12" data-mp="3ljxu6etsc75f">
              <a href="/crm-business-tools" data-id="element-13" data-mp="3ljg11r2f691q">
                CRM &amp; Business Tools - Centralized Hub, Invoicing, Pipeline
              </a>
            </li>
            <li data-id="element-14" data-mp="2svtm5mnqrhzk">
              <a href="/reputation-management" data-id="element-15" data-mp="2swbsjc44bcl7">
                Reputation Management - Automated Reviews, Trust Building
              </a>
            </li>
            <li data-id="element-16" data-mp="18boiuhysu3uu">
              <a href="/ad-campaigns" data-id="element-17" data-mp="18byd4hqvmx6c">
                Ad Campaign Management - Google Ads, Meta Ads, and local lead
                platforms
              </a>
            </li>
            <li data-id="element-18" data-mp="yhepoy2191j2">
              <a href="/web-design-seo" data-id="element-19" data-mp="ydqwk00i2h4v">Web Design &amp; Local SEO</a>
            </li>
          </ul>
          <h2 data-id="element-20" data-mp="13cbv7v03ssr7">Contact Us</h2>
          <p data-id="element-21" data-mp="1r3r6id9uykel">
            Phone: <a href="tel:6233000708" data-id="element-22" data-mp="1r5kcdqcnd0lj">(623) 300-0708</a>
          </p>
          <p data-id="element-23" data-mp="1w33sywwthpgn">
            Email:{' '}
            <a href="mailto:info@viridiaanalytics.com" data-id="element-24" data-mp="1w20x0akn0wtv">
              info@viridiaanalytics.com
            </a>
          </p>
          <p data-id="element-25" data-mp="1i5ngp4rub1gz">Location: Phoenix, AZ - Serving Local Businesses</p>
          <h2 data-id="element-26" data-mp="1m3uze55v6cut">Quick Links</h2>
          <ul data-id="element-27" data-mp="1m793bhu6eu4d">
            <li data-id="element-28" data-mp="1m70m5dr0t2nd">
              <a href="/about" data-id="element-29" data-mp="6onu8ps6bguv">About Us</a>
            </li>
            <li data-id="element-30" data-mp="6n4d6wyp11s1">
              <a href="/case-studies" data-id="element-31" data-mp="6qs3zocr7a32">Case Studies</a>
            </li>
            <li data-id="element-32" data-mp="arkc2e9w38xr">
              <a href="/pricing" data-id="element-33" data-mp="anwkhko08wlo">Pricing</a>
            </li>
            <li data-id="element-34" data-mp="qy71ivpbgr5x">
              <a href="/contact" data-id="element-35" data-mp="qyqa3lt2u37a">Book a Free Strategy Call</a>
            </li>
            <li data-id="element-36" data-mp="m5dxka1o9muw">
              <a href="/privacy" data-id="element-37" data-mp="m4uir27bjel3">Privacy Policy</a>
            </li>
            <li data-id="element-38" data-mp="h6km0n5y45xd">
              <a href="/terms" data-id="element-39" data-mp="h8414afv8axk">Terms of Service</a>
            </li>
          </ul>
        </div>
      </noscript>
      <main role="main" className="flex-grow" data-id="element-40" data-mp="c9u5jyq8b8bf">
        <Routes data-id="element-41" data-mp="19vrizhpr4ngi">
          <Route path="/" element={<Home data-id="element-43" data-mp="19uouthjtcz4a" />} data-id="element-42" data-mp="19w9nt2qhca01" />
          <Route path="/how-it-works" element={<HowItWorks data-id="element-45" data-mp="14x6j5jeew5sl" />} data-id="element-44" data-mp="19v88un6cf3d1" />
          <Route path="/getting-started" element={<GettingStarted data-id="element-47" data-mp="14uu0f40txreh" />} data-id="element-46" data-mp="14xyfiwfu27jx" />
          <Route path="/why" element={<Why data-id="element-49" data-mp="zwslmvafse8t" />} data-id="element-48" data-mp="zxk6pc6eqtku" />
          <Route path="/pricing" element={<PricingPage data-id="element-51" data-mp="vw8mxna7t2kk" />} data-id="element-50" data-mp="zw93bdgvjnu9" />
          <Route path="/contact" element={<Contact data-id="element-53" data-mp="vvp32110843w" />} data-id="element-52" data-mp="vx0781yd3dvj" />
          <Route path="/services" element={<Navigate to="/how-it-works" replace data-id="element-55" data-mp="3kokk9alp8wxs" />} data-id="element-54" data-mp="vybdq9j6yzqc" />
          <Route path="/ai-lead-conversion" element={<Navigate to="/how-it-works" replace data-id="element-57" data-mp="3gmpo0kiml9qv" />} data-id="element-56" data-mp="3kpdx8tb94iod" />
          <Route path="/automations" element={<Navigate to="/how-it-works" replace data-id="element-59" data-mp="1w4ezeced2rhs" />} data-id="element-58" data-mp="3gl632gm0yair" />
          <Route path="/custom-automations" element={<Navigate to="/how-it-works" replace data-id="element-61" data-mp="2060bvwmzh3rg" />} data-id="element-60" data-mp="1w5zwo9s28ojc" />
          <Route path="/crm-business-tools" element={<Navigate to="/how-it-works" replace data-id="element-63" data-mp="2553gjfz1x7yw" />} data-id="element-62" data-mp="206timxlxzt9l" />
          <Route path="/reputation-management" element={<Navigate to="/how-it-works" replace data-id="element-65" data-mp="29vtl4qznl6sj" />} data-id="element-64" data-mp="254bmwap0lkb9" />
          <Route path="/ad-campaigns" element={<Navigate to="/how-it-works" replace data-id="element-67" data-mp="29xo9kfa4vh1d" />} data-id="element-66" data-mp="29wlhw54zlake" />
          <Route path="/google-business-profile-setup" element={<Navigate to="/how-it-works" replace data-id="element-69" data-mp="2jthryfaja4r2" />} data-id="element-68" data-mp="2etv6xjogrk7p" />
          <Route path="/web-design-seo" element={<Navigate to="/pricing" replace data-id="element-71" data-mp="2nv2yzk0dzotc" />} data-id="element-70" data-mp="2jw3x689yc864" />
          <Route path="/about" element={<Navigate to="/why" replace data-id="element-73" data-mp="2supcluk4n72o" />} data-id="element-72" data-mp="2nwe2rjtu0wkg" />
          <Route path="/case-studies" element={<CaseStudiesPage data-id="element-75" data-mp="2ssla9h1vmg4i" />} data-id="element-74" data-mp="2stecq5tsyjgu" />
          <Route path="/case-studies/tfp-landscaping" element={<TfpLandscapingPage data-id="element-77" data-mp="tjeiveif5g7d" />} data-id="element-76" data-mp="ti3fvgwsschb" />
          <Route path="/case-studies/finish-coat-painting" element={<FinishCoatPaintingPage data-id="element-79" data-mp="yihp32a4xsgx" />} data-id="element-78" data-mp="ygepprn3emzj" />
          <Route path="/blog" element={<BlogPage data-id="element-81" data-mp="21ru6le1gkffv" />} data-id="element-80" data-mp="21slr9ttiosrd" />
          <Route path="/blog/how-to-choose-marketing-agency" element={<HowToChooseMarketingAgency data-id="element-83" data-mp="1wukc3jz7pdl6" />} data-id="element-82" data-mp="1wshae2op5w0m" />
          <Route path="/blog/why-response-time-makes-or-breaks-your-yelp-ads" element={<WhyResponseTimeMakesOrBreaksYourYelpAds data-id="element-85" data-mp="25s4bsohff1to" />} data-id="element-84" data-mp="2atbkcpre851e" />
          <Route path="/blog/faster-yelp-replies-more-landscaping-estimates" element={<FasterYelpRepliesMoreLandscapingEstimates data-id="element-87" data-mp="2frlgp3outbol" />} data-id="element-86" data-mp="2kq6i36fue1em" />
          <Route path="/blog/ai-receptionist-vs-human-receptionist-cost" element={<AiReceptionistVsHumanReceptionistCost data-id="element-89" data-mp="2thylwyad2ca8" />} data-id="element-88" data-mp="2fp91gyahdff8" />
          <Route path="/blog/missed-call-text-back-phoenix-home-services" element={<MissedCallTextBack data-id="element-91" data-mp="33g4m9bgiracz" />} data-id="element-90" data-mp="2pi7pady5l1xs" />
          <Route path="/f/why-response-time-makes-or-breaks-your-yelp-ads" element={<Navigate to="/blog/why-response-time-makes-or-breaks-your-yelp-ads" replace data-id="element-93" data-mp="2yg099vetkxri" />} data-id="element-92" data-mp="33etnxr5ueut9" />
          <Route path="/f/faster-yelp-replies-more-landscaping-estimates" element={<Navigate to="/blog/faster-yelp-replies-more-landscaping-estimates" replace data-id="element-95" data-mp="38576gppk7tyv" />} data-id="element-94" data-mp="3n27mvx2aw2i1" />
          <Route path="/tools/gmail-signature-generator" element={<GmailSignatureGeneratorPage data-id="element-97" data-mp="343lmkkelyff6" />} data-id="element-96" data-mp="2zcvdaw329sf7" />
          <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-99" data-mp="2pez80kwt1rp0" />} data-id="element-98" data-mp="3456ee29jfk9c" />
          <Route path="/terms" element={<TermsOfServicePage data-id="element-101" data-mp="2pgsf21bbydxj" />} data-id="element-100" data-mp="2pg0ian5zya5o" />
        </Routes>
      </main>
      <Footer data-id="element-102" data-mp="2ud94cyu9myc7" />
      <CookieConsent data-id="element-103" data-mp="2uetwkht3y56w" />
    </div>;
}
export function App() {
  useEffect(() => {
    // Cookie-consent gate (added 2026-08-04): a declined choice stored from
    // a previous visit skips these scripts entirely. An accepted or
    // not-yet-decided visitor still gets them by default -- CookieConsent's
    // banner still shows either way so the choice is disclosed, matching
    // the site's own Privacy Policy (which already names Meta/Google as
    // third parties). A decision made THIS session can't un-fire a pixel
    // that already loaded before the banner was clicked, but it's honored
    // on every subsequent page load for as long as it's stored.
    if (getStoredConsent() === 'declined') {
      return;
    }
    // Google Analytics (gtag.js)
    const GA_MEASUREMENT_ID = 'G-C4JZKB2BFQ';
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(gtagScript);
    const gtagInit = document.createElement('script');
    gtagInit.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(gtagInit);
    // Meta Pixel
    const fbScript = document.createElement('script');
    fbScript.text = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '970566142171718');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(fbScript);
    const fbNoscript = document.createElement('noscript');
    const fbImg = document.createElement('img');
    fbImg.height = 1;
    fbImg.width = 1;
    fbImg.style.display = 'none';
    fbImg.src = 'https://www.facebook.com/tr?id=970566142171718&ev=PageView&noscript=1';
    fbNoscript.appendChild(fbImg);
    document.body.appendChild(fbNoscript);
    // GHL Chat Widget
    const chatDiv = document.createElement('div');
    chatDiv.setAttribute('data-chat-widget', '');
    chatDiv.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    chatDiv.setAttribute('data-location-id', 'JLycxFbUVQFY3z4zPpCS');
    document.body.appendChild(chatDiv);
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    document.body.appendChild(script);
    return () => {
      if (gtagScript.parentNode) gtagScript.parentNode.removeChild(gtagScript);
      if (gtagInit.parentNode) gtagInit.parentNode.removeChild(gtagInit);
      if (fbScript.parentNode) fbScript.parentNode.removeChild(fbScript);
      if (fbNoscript.parentNode) fbNoscript.parentNode.removeChild(fbNoscript);
      if (chatDiv.parentNode) chatDiv.parentNode.removeChild(chatDiv);
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);
  return <BrowserRouter data-id="element-104" data-mp="3myu18wuyfh6r">
      <ScrollToTop data-id="element-105" data-mp="3myatua2xkb6z" />
      <Routes data-id="element-106" data-mp="3mxr9yntpzcqb">
        <Route path="/robots.txt" element={<RobotsTxt data-id="element-108" data-mp="3hzpusdzezxk4" />} data-id="element-107" data-mp="3mx991dw44ac2" />
        <Route path="/sitemap.xml" element={<SitemapXml data-id="element-110" data-mp="3hz7ospmya4z0" />} data-id="element-109" data-mp="3i09270rfv3jw" />
        <Route path="/*" element={<SiteLayout data-id="element-112" data-mp="3d0ech0jegk0f" />} data-id="element-111" data-mp="3i1tzuz91v2lz" />
      </Routes>
    </BrowserRouter>;
}